// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "span[data-v-f4cbbba0]{font-weight:700;word-break:keep-all;margin-left:1rem}.false.inverted[data-v-f4cbbba0],.true[data-v-f4cbbba0]{color:var(--true-color)}.false[data-v-f4cbbba0],.true.inverted[data-v-f4cbbba0]{color:var(--false-color)}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
